import { matchPath } from "react-router-dom";
import { PUBLIC_ROUTES } from "SecuredRoute/isPublicRoute";

const ACCEPT_INVITE_PATH = "/accept-invite";
const INVITE_PATH = "/invite";
const ORG_ACCEPT_INVITATION_ACCEPTED_PATH =
  "/org/:orgId/accept-invitation/accepted";

function parsePath(pathAndSearch?: string | null): URL | null {
  if (!pathAndSearch) return null;

  try {
    return new URL(pathAndSearch, "https://brev.local");
  } catch {
    return null;
  }
}

function isInvitationLink(pathAndSearch?: string | null): boolean {
  const url = parsePath(pathAndSearch);
  if (!url) return false;

  if (url.pathname === ACCEPT_INVITE_PATH) {
    return Boolean(url.searchParams.get("inviteId"));
  }

  if (
    matchPath(url.pathname, {
      path: PUBLIC_ROUTES.ORG_ACCEPT_INVITATION,
      exact: true,
    }) ||
    matchPath(url.pathname, {
      path: ORG_ACCEPT_INVITATION_ACCEPTED_PATH,
      exact: true,
    })
  ) {
    return Boolean(url.searchParams.get("token"));
  }

  if (url.pathname === INVITE_PATH) {
    return Boolean(url.searchParams.get("token"));
  }

  return false;
}

export function isFollowingInvitationLink(
  currentPathAndSearch: string,
  redirectPathAndSearch?: string | null,
): boolean {
  return (
    isInvitationLink(currentPathAndSearch) ||
    isInvitationLink(redirectPathAndSearch)
  );
}
